<script setup lang="ts">
import { RouterView } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'
import Image from '@uiKit/elements/Image.vue'
import logo from '@assets/images/full_logo.png'

// Chrome-free shell for public content pages (the seller guides, Policies & Legal).
//
// Deliberately not AppLayout: these pages are readable without a session and
// are meant to be shareable, so they carry no top nav, no sidebar, no profile
// menu and no app affordances a signed-out reader couldn't use. The brand mark
// is a mark, not a link — every in-app destination behind it would bounce an
// anonymous reader to sign-in.
</script>

<template>
  <Box is="main" direction="col" class="content-shell">
    <Box is="header" flex align="center" class="content-shell__masthead">
      <Image :src="logo" alt="Sliceal" height="26" class="content-shell__logo" />
    </Box>

    <Box class="content-shell__body">
      <RouterView />
    </Box>
  </Box>
</template>

<style scoped>
.content-shell {
  min-height: 100dvh;
  background: var(--p-surface-50);
}

.content-shell__masthead {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--p-content-border-color);
  background: var(--p-surface-0);
}

.content-shell__logo {
  width: auto;
}

.content-shell__body {
  flex: 1;
  padding: 1.5rem 1.5rem 3rem;
  max-width: 1280px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

@media (max-width: 992px) {
  .content-shell__masthead {
    padding: 0.875rem 1rem;
  }

  .content-shell__body {
    padding: 1rem 1rem 2.5rem;
  }
}
</style>
